import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/Login";
import { RequireAuth } from "../auth/RequireAuth";
import { AppLayout } from "../layouts/AppLayout";
import AssignmentsPage from "../pages/Assignments";
import AppUsers from "../pages/AppUsers";
import AppUserProfile from "../pages/AppUserProfile";
import ActsPage from "../pages/Acts";
import SettingsPage from "../pages/Settings";
import DashboardPage from "../pages/Dashboard";
import ItemsPage from "../pages/Items";
import SuppliersPage from "../pages/Suppliers";
import SupplierProfile from "../pages/SupplierProfile";
import AuditLogPage from "../pages/AuditLog";
import UserShortRedirect from "pages/app-users/UserShortRedirect";
import EmployeeLayout from "../layouts/EmployeeLayout";
import EmployeeDashboard from "../pages/employee/EmployeeDashboard";


const Dashboard = () => <div className="p-6">Дашборд</div>;
const Items = () => <div className="p-6">Товары</div>;
const Acts = () => <div className="p-6">Акты</div>;
const Settings = () => <div className="p-6">Настройки</div>;

export const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route element={<RequireAuth />}>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/items" element={<ItemsPage />} />
        <Route path="/suppliers" element={<SuppliersPage />} />
        <Route path="/suppliers/:id" element={<SupplierProfile />} /> {/* Added route */}
        <Route path="/assignments" element={<AssignmentsPage />} />
        <Route path="/users" element={<AppUsers />} />
        <Route path="/u/:code" element={<UserShortRedirect />} />
        <Route path="/users/:id" element={<AppUserProfile />} />
        <Route path="/acts" element={<ActsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/audit" element={<AuditLogPage />} />

      </Route>

      <Route element={<EmployeeLayout />}>
        <Route path="/employee" element={<EmployeeDashboard />} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);
